// #2749: what the left menu shows. The top tabs (narrow screens) and the
// left menu (wide screens) read the same tab and account name. They carry no
// count: the tiles above the list count the chosen scope (2026-10-28).

// #2856: 「ゴール」 > 今日 / すべて show the list (rows due by today, or any
// date); 完了 keeps the goal cards for the goals already done.
export type MainTab = 'today' | 'all' | 'done' | 'create';

export type AppNavState = {
  tab: string;
  name: string;
};

const MAIN_TABS: MainTab[] = ['today', 'all', 'done', 'create'];

const state: AppNavState = { tab: 'today', name: '' };
const listeners = new Set<(state: AppNavState) => void>();

function emit() {
  const snapshot = { ...state };
  listeners.forEach((listener) => listener(snapshot));
}

export function getAppNav(): AppNavState {
  return { ...state };
}

export function subscribeAppNav(listener: (state: AppNavState) => void): () => void {
  listeners.add(listener);
  listener(getAppNav());
  return () => listeners.delete(listener);
}

/** Marks the shown tab in the top tabs and the left menu. */
export function markMainTab(tab: string) {
  document.querySelectorAll('.main-tab').forEach((el, i) => {
    el.classList.toggle('active', MAIN_TABS[i] === tab);
  });
  state.tab = tab;
  emit();
}

export function setAccountName(name: string) {
  const el = document.getElementById('userName');
  if (el) el.textContent = name;
  state.name = name;
  emit();
}
